<template>
  <div class="workflow body">
    <div class="left-area m10">
      <div class="flow-title p20">
        <span>节点名称</span>
        <el-input class="margin10"
                  v-model="currentNode.nodeName"></el-input>
      </div>
      <div class="flow-title p20">
        <span>审批人</span>
        <choose-person :multiCheck="false"
                       v-model="personList"
                       :searchAble="true"></choose-person>
      </div>
    </div>
    <div class="right-area m10 flex page-background-color">
      <div class="ml20 mt20">
        <el-button type="primary"
                   v-if="isAdd"
                   @click.stop="save()">{{$t('workOrder.button.save')}}</el-button>
        <el-button type="primary"
                   @click.stop="commit()">{{$t('workOrder.button.commit')}}</el-button>
        <el-button type="primary"
                   v-if="isAdd"
                   @click.stop="deleteFlow()">{{$t('workOrder.button.delete')}}</el-button>
        <el-button type="primary"
                   @click.stop="back()">取消</el-button>
      </div>
      <div class="flow-list card-list m20 flex">
        <el-row>
          <el-col :span="3"
                  v-for="(flow, index) in flowList"
                  :key="index"
                  :offset="index > 0 ? 1 : 0">
            <el-card :body-style="{ padding: '0px' }"
                     :shadow="currentNode.order - 1 === index ? 'always' : 'never'">
              <div class="flow-card card p10"
                   @click="editNode(flow)">
                <span class="title">{{flow.nodeName}}</span>
                <div class="nick-name">
                  <h1 class="title"
                      style="line-height: 50px">{{flow.nickName}}</h1>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col v-if="isAdd"
                  :span="3"
                  :offset="1">
            <el-card :body-style="{ padding: '0px' }"
                     shadow="never">
              <div class="flow-card card"
                   @click="addFlow">
                <div class="add iconfont-lunan icon-lunan-jia-copy" />
                <!-- <span class="title create">{{$t('workOrder.title.create')}}</span> -->
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../api'
import { Cache } from '@src/common/utils'
import choosePerson from './choose-person'
export default {
  name: 'workflow',
  components: {
    choosePerson
  },
  data () {
    return {
      templateCode: '',
      currentNode: {
        nodeName: '',
        nickName: '',
        accountNumber: '',
        order: -1
      },
      isAdd: false,
      approvalPerson: {},
      personList: [],
      flowList: []
    }
  },
  watch: {
    personList (val) {
      this.approvalPerson = val[0] || {};
      this.currentNode.accountNumber = this.approvalPerson.accountNumber
      this.currentNode.nickName = this.approvalPerson.nickName
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.templateCode) {
      this.templateCode = this.$route.query.templateCode
    }
    this.queryFlow()
  },
  methods: {
    queryFlow () {
      this.$fetch(api.workOrder.queryWorkOrderFlowList, {
        templateCode: this.templateCode
      }).then(res => {
        if (res.success) {
          this.flowList = res.returnObj
          this.initNode();
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    initNode () {
      let tempList = Cache.get('NodeList');
      if (this.flowList.length > 0) {
        this.isAdd = false;
      } else if (tempList && tempList[this.templateCode] && tempList[this.templateCode].length > 0) {
        this.isAdd = true;
        this.flowList = tempList[this.templateCode]
      } else {
        this.isAdd = true;
      }
    },
    addFlow () {
      const length = this.flowList.length;
      this.flowList.push({
        nodeName: '节点名称',
        accountNumber: '',
        nickName: '',
        order: length + 1
      })
    },
    editNode (val) {
      this.currentNode = val
      this.personList = [val];
    },
    save () {
      let obj = {};
      obj[this.templateCode] = this.flowList
      Cache.put('NodeList', obj)
      this.$message({
        message: '保存成功',
        type: 'success',
        duration: 2000
      })
    },
    commit () {
      if (!this.isAdd) {
        this.$fetch(api.workOrder.updateWorkOrderFlow, {
          templateCode: this.templateCode,
          workOrderFlowList: this.flowList
        }).then(res => {
          if (res.success) {
            this.$message({
              message: '发布成功',
              type: 'success',
              duration: 2000
            })
            this.$router.go(-1)
          } else {
            this.$message.error(res.msgContent)
          }
        })
        return
      }

      // if (this.flowList.length === 0) {
      //   this.$message({
      //     type: 'warning',
      //     duration: 2000,
      //     message: '请先添加节点'
      //   })
      //   return
      // }
      this.$fetch(api.workOrder.addWorkOrderFlow, {
        templateCode: this.templateCode,
        workOrderFlowList: this.flowList
      }).then(res => {
        if (res.success) {
          this.$message({
            message: '发布成功',
            type: 'success',
            duration: 2000
          })
          this.$router.go(-1)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    deleteFlow () {
      this.flowList.splice(this.currentNode.order - 1, 1)
      for (let index = 0; index < this.flowList.length; index++) {
        this.flowList[index].order = index + 1;
      }
    },
    resetData () {
      this.currentNode.nodeName = '';
      this.currentNode.nickName = '';
      this.currentNode.accountNumber = '';
      this.currentNode.order = -1;
    },
    back () {
      this.$router.go(-1)
    },
  }
}
</script>

<style>
</style>